import { PuiAutocomplete } from "@portnet/ui";
import React from "react";
const AppAutocomplete = React.forwardRef((props, ref) => {
  return <PuiAutocomplete ref={ref} {...props} />;
});

export default AppAutocomplete;
